var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"max-width":"344"}},[_c('v-card-text',{staticClass:"d-flex justify-space-between px-4"},_vm._l((_vm.identifierArray),function(char){return _c('p',{staticClass:"display-1 text--primary mb-0"},[_vm._v(" "+_vm._s(char)+" ")])}),0),_c('v-card-subtitle',[_vm._v(_vm._s(_vm.$t('caption')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }